<template>
  <div>
    <div
      class="small-shadow bg-white rounded-lg card-gradient mt-12 mb-10 py-12 px-8"
    >
      <trac-custom-header class="mb-3">
        <template slot="trailing"> Details</template>
      </trac-custom-header>

      <div class="grid grid-cols-12 gap-20">
        <div class="col-span-8 grid grid-cols-12 gap-10">
          <div class="col-span-6">
            <trac-input
              v-model="formData.name"
              placeholder="Subcategory Name"
            />
          </div>
          <div class="col-span-6">
            <trac-input
              v-model="category.name"
              placeholder="Category Name"
              disabled
            />
          </div>
        </div>
        <div class="col-span-4 flex gap-5">
          <trac-button
            type="submit"
            variant="small"
            :disabled="!formData.name"
            @button-clicked="openActionModal('update')"
          >
            <div class="leading-7 font-bold">UPDATE</div>
          </trac-button>
          <trac-button
            type="submit"
            variant="danger-outline"
            @button-clicked="openActionModal('delete')"
          >
            <div class="leading-7">DELETE</div>
          </trac-button>
        </div>
      </div>
    </div>

    <trac-loading v-if="loading" />

    <trac-modal v-if="showActionModal" @close="showActionModal = false">
      <div class="mb-12">
        <div class="text-center mt-16 mb-8">
          <span>Are you sure you want to {{ modalText }} this category?</span>
        </div>

        <div class="flex justify-center">
          <div class="w-3/5">
            <trac-button
              class="uppercase text-xs w-full"
              @button-clicked="submit"
            >
              {{ modalText }}
            </trac-button>
          </div>
        </div>
      </div>
    </trac-modal>

    <trac-success-modal v-if="showSuccessModal" @close="close">
      <span>Subcategory has been {{ modalText }}d successfully.</span>
    </trac-success-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { eventBus } from "@/eventBus";

export default {
  name: "CategoryDetails",
  props: {
    subCategory: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      modalText: "",
      showActionModal: false,
      showSuccessModal: false,
      formData: {
        name: this.subCategory.name,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      category: "GET_PRODUCT_CATEGORY",
    }),

    categoryId() {
      return this.$route.params?.id;
    },
    subCategoryId() {
      return this.$route.params?.sub_id;
    },
    isUpdate() {
      return this.modalText === "update";
    },
  },
  methods: {
    ...mapActions([
      "EDIT_PRODUCT_SUBCATEGORY",
      "FETCH_PRODUCTS_CATEGORY",
      "DELETE_PRODUCT_SUBCATEGORY",
    ]),
    async submit() {
      this.loading = true;

      const mutateFn = this.isUpdate
        ? "EDIT_PRODUCT_SUBCATEGORY"
        : "DELETE_PRODUCT_SUBCATEGORY";
      const payload = this.isUpdate
        ? {
            ...this.formData,
            category_id: this.categoryId,
            sub_category_id: this.subCategoryId,
          }
        : this.subCategoryId;
      try {
        const res = await this[mutateFn](payload);
        if (res.status) {
          this.toggleSuccess();
        }
      } catch (error) {
        eventBus.$emit("trac-alert", {
          message: error?.response?.data?.message,
        });
      } finally {
        this.loading = false;
      }
    },
    openActionModal(value) {
      this.modalText = value;
      this.showActionModal = true;
    },
    toggleSuccess() {
      this.showActionModal = false;
      this.showSuccessModal = !this.showSuccessModal;
      this.isUpdate && this.FETCH_PRODUCTS_CATEGORY(this.categoryId);
    },
    close() {
      if (!this.isUpdate) {
        this.$router.push({
          path: `/productsinventory/categories/${this.categoryId}`,
        });

        return;
      }

      this.toggleSuccess();
    },
  },
};
</script>

<style lang="scss" scoped></style>
